var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    ref: "modal",
    staticClass: "cs-modal-overlay",
    class: {
      'cs-modal-overlay-showed': _vm.visible
    },
    style: {
      top: "".concat(_vm.topPosition, "px"),
      bottom: "".concat(_vm.bottomPosition, "px"),
      backgroundColor: _vm.colorOverlay,
      alignItems: "".concat(_vm.contentPosition)
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event);
      }
    }
  }, [_c('div', {
    staticClass: "cs-modal"
  }, [_vm._t("content-wrapper", [_vm.$slots.hasOwnProperty('header') ? _c('div', {
    staticClass: "cs-modal-header"
  }, [_vm._t("header")], 2) : _vm._e(), _vm._t("body", [_c('div', {
    staticClass: "cs-modal-body"
  }, [_vm._t("default")], 2)])])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }